import { StyleSheet } from "@react-pdf/renderer"

export const paymentDataStyles=()=>{

    const paymentData = StyleSheet.create({

        container: {
            flexDirection: 'row',
            justifyContent:'center',
            marginTop:2,
            borderWidth:1,
            width:'100%',

        },
        subContainer: {
            flex:1,
            paddingHorizontal: 5,
            paddingVertical:2,
            justifyContent:'center',
            alignItems:'center'
        },
    })

    return {
        paymentData
    }
}